// This file was automatically generated from appshared.dialog.refileRxRefill.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.refileRxRefill');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.refileRxRefill.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><div class="pad10 mb10 el8AppText el8RedDashedBox">This workflow is only for refiling prescription renewal requests sent to the incorrect patient. Deny this patient\'s prescription renewal request and provide a reason if you do not wish to approve it. If this is not your patient, deny the request, add \'unknown\' for the patient address, and enter your practice\'s city, state, and zip. Be aware that delayed responses to renewal requests may result in loss of electronic refill privileges for prescribers.</div><form></form></div>');
  if (!opt_sb) return output.toString();
};
